import { gql } from '@apollo/client';
export const documentNameQuery = gql `
  query documentName($id: ID!) {
    fileSystemDocument: fileSystemDocument(id: $id) {
      id
      name
    }
  }
`;
